import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-device-global-map",
  "use": "icon-soc-l1-device-global-map-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-l1-device-global-map\">\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <circle cx=\"480\" cy=\"448\" r=\"288\" />\n    <path d=\"M192 448h576M480 160c96 96 144 192 144 288s-48 192-144 288M480 160c-96 96-144 192-144 288s48 192 144 288\" />\n    <path d=\"M640 640c0-64 48-112 112-112s112 48 112 112c0 88-112 176-112 176s-112-88-112-176z\" />\n    <circle cx=\"752\" cy=\"640\" r=\"28\" fill=\"currentColor\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-device-global-map.svg
// module id = EUCB
// module chunks = 492